<template>
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.63989 1.08838L4.85348 4.91209L1.06706 1.08838"
      stroke="#35312E"
      stroke-width="1.16505"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default { name: "svg-caret-down" };
</script>
